import Logo from "../Logo";

export default function Header() {
    return (
        <header className='h-20 w-full border-b-4 border-primary bg-white px-3 py-1 shadow-md'>
            <Logo className='h-full' />
        </header>
    );
}